import { mobileModule } from '@/store/mobile/module'
import { type PPQueryParams } from '@/utils'
import { subscriptionModule } from '@/store/subscription/module'

const buildMobileStateFromQueryParams = (queryParams: PPQueryParams) => {
    const { platform, productIndex, ulPath, priorScreenName, bundleId } = queryParams

    mobileModule.state.mobileAppPath = ulPath || null
    mobileModule.state.productIndex = productIndex && !Number.isNaN(Number(productIndex))
        ? Number(productIndex)
        : null
    mobileModule.state.platform = (platform === 'Android' || platform === 'iOS') ? platform : 'Web'
    mobileModule.state.priorScreenName = priorScreenName || null
    mobileModule.state.bundleId = bundleId || null

    if (ulPath) {
        mobileModule.state.hasArrivedFromMobile = true
    }
}

// These query params could potentially be used for non-mobile purposes,
// so we handle them a bit separately from ones used just to return to the mobile app
const clearUpgradeContextInheritedFromQueryParams = () => {
    mobileModule.state.platform = null
    mobileModule.state.productIndex = null
    mobileModule.state.bundleId = null
}

/**
 * Clear out-of-app-purchase state tracking that we came from mobile app
 */
const clearOOAPState = () => {
    mobileModule.state.mobileAppPath = null
    mobileModule.state.hasArrivedFromMobile = false
    clearUpgradeContextInheritedFromQueryParams()
}

const returnToMobileApp = () => {
    const url = getUniversalLinkToApp()
    if (url) {
        window.open(encodeURI(url))
    }

    // clear the OOAP-specific state
    clearOOAPState()
}


// build full URL for Universal Link using appPath & subscription result
const getUniversalLinkToApp = (): string => {
    const appPath = mobileModule.state.mobileAppPath
    const didSubscribe = !!subscriptionModule.getters.getSubscriptionForExamId()
    // right now we know it's always an 'Upgrade' context, but if used in other contexts we need to make this flexible
    const priorScreen = 'Upgrade'
    // do not specify a particular screen eg study, use 'openApp' path to return to prior location
    return `https://pocketprep.com/apps/${appPath}/openApp?priorScreen=${priorScreen}&didSubscribe=${didSubscribe}`
}

export default {
    buildMobileStateFromQueryParams,
    clearUpgradeContextInheritedFromQueryParams,
    returnToMobileApp,
    clearOOAPState,
    getUniversalLinkToApp,
}
